import React from 'react';
import numeral from 'numeral';

const SingleNumberWidget = ({
    value,
    unit,
    showOnMapCallback,
    colorRange,
}) => {
    const showOnMapHandler = () => {
        if (showOnMapCallback) {
            showOnMapCallback();
        }
    }
    return (
        <div>
            <div className="site-planning__sidebar-data-widget__single-number">
                {numeral(value).format('0,0')}
                {unit &&
                    <span className="site-planning__sidebar-data-widget__single-number single-number-unit">{unit}</span>
                }
            </div>
            {showOnMapCallback &&
                <div className="site-planning__sidebar-data-widget__controls">
                    <p
                        className="site-planning__sidebar-data-widget__show-on-map-button"
                        onClick={showOnMapHandler}
                    >Hiện trên bản đồ</p>
                </div>
            }
            <div className="site-planning__sidebar-data-widget__color-range">
                {colorRange && colorRange.map((color, index) =>
                    <div
                        key={`${index}-color`}
                        className="site-planning__sidebar-data-widget__color"
                        style={color ? { backgroundColor: `rgb(${color.join(',')})` } : null}
                    />
                )}
            </div>
        </div>
    );
}

export default SingleNumberWidget;